import { FormsIcon } from 'src/components/Icons/Forms';

export const INTAKE_FORMS = {
  TITLE: 'Forms',
};

export const INTAKE_FORMS_RESPONSE = {
  icon: FormsIcon,
};
